$(function(){
	$('.bxslider').bxSlider({
	    auto: true,
	    slideWidth: 680,
	    minSlides: 1,
	    infiniteLoop: true,
	    controls: false,
	    useCSS:false
    });
});
